import { useSosRejectedContainerQuery, useSosRejectedContainerRefundMutation } from '@/graphql';

import { SosRejectedView } from './SosRejectedView';

const SosRejectedContainer = () => {
    const { data, error, loading, refetch } = useSosRejectedContainerQuery({ variables: { status: 'REJECTED' }, fetchPolicy: 'network-only' });

    const [refundSos] = useSosRejectedContainerRefundMutation({
        onCompleted: () => {
            refetch();
        },
        onError: (error) => {
            console.error('Refund error:', error);
        },
    });

    if (error) return 'Error';

    // const items = data?.sosByStatus;
    const items = data?.sosByStatus ? [...data.sosByStatus].sort((a, b) => (a?.status === 'REFUND_REQUESTED' ? -1 : b?.status === 'REFUND_REQUESTED' ? 1 : 0)) : [];

    const handleRefund = (id: string) => {
        refundSos({
            variables: {
                id,
                sessionId: 'admin_session', // You might want to get this from context or props
            },
        });
    };

    return <SosRejectedView data={items} loading={loading} onRefund={handleRefund} />;
};

export { SosRejectedContainer };
